import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';
import { openAiProductNameAPI } from './../api-services/OpenAi.services';

export const OpenAiContext = createContext();
const OpenAiProvider = ({ children }) => {
  const [aiProductNameResponse, setAiProductNameResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const onAiProductName = async (payload) => {
    try {
       setAiProductNameResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await openAiProductNameAPI(payload);

      if (data.hasError) {
           setAiProductNameResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return;
      }

      if (data.data?.success) {
           setAiProductNameResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      } else {
           setAiProductNameResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: 'Non message need to work',
        });
      }
      return data;
    } catch (error) {
      console.log('---Catch black onAiProductName', error);
      setAiProductNameResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  return (
    <OpenAiContext.Provider
      value={{
        aiProductNameResponse,
        setAiProductNameResponse,
        onAiProductName,
      }}
    >
      {children}
    </OpenAiContext.Provider>
  );
};

export default OpenAiProvider;
